import { Layout, Row, Space, Spin, Typography } from "antd";
import { useLayoutEffect, useState } from "react";
import DuplicateLogo from "../../../../assets/icons/settings/cloner.svg";
import TwizzLogo from "../../../../assets/icons/twizz-app.png";
import { default as EventImg } from "../../../../assets/images/live-fight-event/image-event-03-05.webp";
import EventAuthModalImg from "../../../../assets/images/live-fight-event/image-event-auth.webp";
import PopCornImg from "../../../../assets/images/popcorn.webp";
import InfoTicketLiveEventComponent from "../../../../components/LiveEventComponent/InfoTicketLiveEventComponent";
import PublicAuthentificationModalComponent from "../../../../components/PublicAuthentificationModalComponent";
import SpinnerComponent from "../../../../components/SpinnerComponent/SpinnerComponent";
import "./index.less";

const FanLiveEventPublicPage = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useLayoutEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "auto",
    });
  }, [isModalVisible]);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const hideModal = () => {
    setIsModalVisible(false);
  };

  return (
    <Spin spinning={isLoading} style={{ maxHeight: "100%" }} indicator={<SpinnerComponent />}>
      <Layout>
        <Layout.Content className={`public-live-event-wrapper gradient-background ${isModalVisible ? "no-scroll-page" : ""}`} onClick={showModal}>
          <Row className="public-live-header-container" align="middle">
            <Space className="title-container">
              <img src={TwizzLogo} width={180} alt="Loly" height={35} />
              <img className="popcorn-img" src={PopCornImg} width={22} height={30} alt="PopCorn" />
            </Space>
            <div className="tickets-container" onClick={showModal}>
              <img src={DuplicateLogo} width={14} alt="PopCorn" />
              <Typography.Text className="text">Billetterie</Typography.Text>
            </div>
          </Row>

          <div className="event-img-container">
            <img className="event-img" src={EventImg} alt="" />
          </div>

          <InfoTicketLiveEventComponent alreadyReserved={false} onButtonClick={showModal} />
        </Layout.Content>
        <PublicAuthentificationModalComponent
          avatar={EventAuthModalImg}
          title="Inscrivez-vous pour prendre un ticket"
          visible={isModalVisible}
          onClose={hideModal}
          isFightEvent={true}
        />
      </Layout>
    </Spin>
  );
};

export default FanLiveEventPublicPage;
